import { Card, Divider } from 'antd';
import React from 'react';
import { LogTableRow } from '../../../../hooks/api/logs';
import JsonBlock from '../../../Common/JsonBlock';
import EmailsLogContent from './EmailsLogContent';

interface LogExpandedRowProps {
  record: LogTableRow;
}

export default function LogExpandedRow({
  record,
}: LogExpandedRowProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <IsMbsRequestContent record={record} />

      <Divider>Differences</Divider>
      <LogExpandedRowInner record={record} />
    </div>
  );
}

function IsMbsRequestContent({
  record,
}: LogExpandedRowProps) {
  if (!record.requestToMbs?.body && !record.requestToMbs?.query) {
    return null;
  }

  return (
    <div>
      <p style={{ fontSize: '16px', fontWeight: '500' }}>MBS request params:</p>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '16px',
        }}
      >
        {[{ label: 'Body', data: record.requestToMbs?.body },
          { label: 'Query', data: record.requestToMbs?.query }].filter(Boolean).map(({ label, data }) => (
            <JsonBlock key={crypto.randomUUID()} title={label} data={data} compareWith={data} />
        ))}
      </div>
    </div>

  );
}

function LogExpandedRowInner({
  record,
}: LogExpandedRowProps) {
  if (record.entityType === 'emails') {
    return (
      <EmailsLogContent record={record} />
    );
  }

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '16px',
      }}
    >
      <Card size="small">
        <JsonBlock
          title="Before"
          data={record.before}
          compareWith={record.after}
        />
      </Card>

      <Card size="small">
        <JsonBlock
          title="After"
          data={record.after}
          compareWith={record.before}
        />
      </Card>
    </div>
  );
}
